import { render, staticRenderFns } from "./SystemSettingsDisplay.vue?vue&type=template&id=6757d4df&scoped=true&lang=pug&"
import script from "./SystemSettingsDisplay.vue?vue&type=script&lang=ts&"
export * from "./SystemSettingsDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./SystemSettingsDisplay.vue?vue&type=style&index=0&id=6757d4df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6757d4df",
  null
  
)

export default component.exports